import React from 'react';
import { BetaCodesSection, BetaUsersSection } from './beta/BetaSections';
import { BetaStatsCards } from './beta/BetaHelpers';
import { useAdminBeta } from './hooks/useAdminBeta';

const AdminBetaManagement = () => {
  const {
    stats, codes, betaUsers,
    codeFilter, setCodeFilter,
    userFilter, setUserFilter,
    generateQty, assignees, generating,
    activeSection, setActiveSection,
    updateQuantity, updateAssignee,
    handleGenerate, handleRevoke,
  } = useAdminBeta();

  return (
    <div className="space-y-6">
      <BetaStatsCards stats={stats} />

      <div className="flex gap-2">
        <button
          data-testid="beta-section-codes"
          onClick={() => setActiveSection('codes')}
          className={`px-4 py-2 rounded-lg text-sm font-semibold transition ${activeSection === 'codes' ? 'bg-green-500 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}
        >
          Beta Codes
        </button>
        <button
          data-testid="beta-section-users"
          onClick={() => setActiveSection('users')}
          className={`px-4 py-2 rounded-lg text-sm font-semibold transition ${activeSection === 'users' ? 'bg-green-500 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}
        >
          Beta Users
        </button>
      </div>

      {activeSection === 'codes' && (
        <BetaCodesSection
          codes={codes} codeFilter={codeFilter} setCodeFilter={setCodeFilter}
          generateQty={generateQty} assignees={assignees} generating={generating}
          updateQuantity={updateQuantity} updateAssignee={updateAssignee}
          handleGenerate={handleGenerate} handleRevoke={handleRevoke}
        />
      )}

      {activeSection === 'users' && (
        <BetaUsersSection betaUsers={betaUsers} userFilter={userFilter} setUserFilter={setUserFilter} />
      )}
    </div>
  );
};

export default AdminBetaManagement;
